import { UploadedGuestData, UploadedStructureData } from '@features/add-participants-modal/with-excel';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { UnstyledButton } from '@shared/ui/unstyled-button';

interface StatisticsUploadedUsersProps {
  uploadedData: UploadedStructureData | UploadedGuestData;
  onShowErrors: () => void;
}

const getWidth = (value: number, total: number) => {
  if (total === 0) return '0%';
  const percentage = (value / total) * 100;
  return `${percentage}%`;
};

const getPercent = (value: number, total: number) => {
  if (total === 0) return 0;
  return Math.round((value / total) * 100);
};

export const StatisticsUploadedUsers = ({ uploadedData, onShowErrors }: StatisticsUploadedUsersProps) => {
  const isStructure = 'totalUsers' in uploadedData;
  const recognized = isStructure ? uploadedData.succsessUsers : uploadedData.successGuest;
  const unrecognized = isStructure ? uploadedData.errorUsers : uploadedData.errorGuests;
  const total = recognized + unrecognized;
  const shouldShowUnrecognizedButton = Boolean(onShowErrors);

  return (
    <div>
      <div {...stylex.props(styles.content)}>
        <div {...stylex.props(styles.main)}>
          <div {...stylex.props(styles.infoSection)}>
            <div {...stylex.props(styles.accepted)}>Пользователей в файле </div>
            <div {...stylex.props(styles.notAccepted)}>
              Успешно распознанные<p {...stylex.props(styles.progressValue)}>/ {getPercent(recognized, total)}%</p>
            </div>

            {!!unrecognized && (
              <div {...stylex.props(styles.unrecongnized)}>
                <div {...stylex.props(styles.unrecongnizedText)}>
                  Не распознанные <p {...stylex.props(styles.progressValue)}>/ {getPercent(unrecognized, total)}%</p>
                </div>
                {shouldShowUnrecognizedButton && (
                  <UnstyledButton {...stylex.props(styles.open)} onClick={onShowErrors}>
                    Показать не распознанные
                  </UnstyledButton>
                )}
              </div>
            )}
          </div>

          <div {...stylex.props(styles.infoWidget)}>
            <div {...stylex.props(styles.progressBarContainer)}>
              <div {...stylex.props(styles.progressBar, styles.total)}>{total}</div>
            </div>
            <div {...stylex.props(styles.progressBarContainer)}>
              <div {...stylex.props(styles.progressBar, styles.recognized(getWidth(recognized, total)))}>
                {recognized}
              </div>
            </div>

            {!!unrecognized && (
              <div {...stylex.props(styles.progressBarContainer)}>
                <div {...stylex.props(styles.progressBar, styles.unrecognized(getWidth(unrecognized, total)))}>
                  {unrecognized}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
